export const IngredientsChecklist = {
  bindings: {
    ingredients: '<',
    checked: '<',
    onToggle: '&',
  },

  template: `
    <div class="ingredients-list px-3 text-left">
      <div class="row">
        <div class="col-md-6">
          <ul class="fa-ul">
            <li
              ng-repeat="ingredient in $ctrl.ingredients track by $index"
              ng-click="$ctrl.onToggle({ item: ingredient })"
              ng-if="$index < ($ctrl.ingredients.length / 2)">
              <ingredients-check
                ingredient="ingredient"
                checked="$ctrl.checked[ingredient.foodId]">
              </ingredients-check>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <ul class="fa-ul">
            <li
              ng-repeat="ingredient in $ctrl.ingredients track by $index"
              ng-click="$ctrl.onToggle({ item: ingredient })"
              ng-if="$index >= ($ctrl.ingredients.length / 2)">
              <ingredients-check
                ingredient="ingredient"
                checked="$ctrl.checked[ingredient.foodId]">
              </ingredients-check>
            </li>
          </ul>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Ingredients/IngredientsChecklist.js